import { message } from 'antd';
import { typesReembolsos } from '../types/typesReembolsos';
import { URL_BASE_REEMBOLSOS } from '../../constants/url';

const headers = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
  'Content-Type': 'application/json',
});

export const startGetLista = (estatus) => async (dispatch) => {
  dispatch({ type: typesReembolsos.setLoading, payload: true });
  try {
    const res = await fetch(`${URL_BASE_REEMBOLSOS}/GetListaPorEstatus/${estatus}`, { headers: headers() });
    if (!res.ok) { message.error(await res.text()); return; }
    const data = await res.json();
    dispatch({ type: typesReembolsos.storeReembolsos, payload: data });
  } catch (e) {
    message.error(e.message || 'Error al cargar reembolsos');
  } finally {
    dispatch({ type: typesReembolsos.setLoading, payload: false });
  }
};

export const startGetDetalle = (reembolsoID) => async () => {
  const res = await fetch(`${URL_BASE_REEMBOLSOS}/GetDetalleReembolso/${reembolsoID}`, { headers: headers() });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
};

export const startCargaDocumento = (reembolsoID, file, esPago = false) => async () => {
  const formData = new FormData();
  formData.append('File', file);
  formData.append('ReembolsoID', reembolsoID);
  formData.append('EsPago', esPago);
  const res = await fetch(`${URL_BASE_REEMBOLSOS}/CargaDocumentoReembolso`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    body: formData,
  });
  if (!res.ok) throw new Error(await res.text());
};

export const startGetFile = (reembolsoDocumentoID) => async () => {
  const res = await fetch(`${URL_BASE_REEMBOLSOS}/GetFile/${reembolsoDocumentoID}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });
  if (!res.ok) throw new Error(await res.text());
  return res.blob();
};

export const startSolicitar = (body) => async () => {
  const res = await fetch(`${URL_BASE_REEMBOLSOS}/SolicitarReembolso`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(body),
  });
  const text = await res.text();
  if (!res.ok) throw new Error(text);
  return Number(text);
};

export const startVoboAutorizacion = (reembolsoID, tipoAutorizacion) => async () => {
  const res = await fetch(`${URL_BASE_REEMBOLSOS}/VoboAutorizacion`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify({ reembolsoID, tipoAutorizacion }),
  });
  if (!res.ok) throw new Error(await res.text());
};

export const startSetPagado = (reembolsoID) => async () => {
  const res = await fetch(`${URL_BASE_REEMBOLSOS}/SetPagado`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify({ reembolsoID }),
  });
  if (!res.ok) throw new Error(await res.text());
};

export const startEliminarDocumento = (reembolsoDocumentoID) => async () => {
  const res = await fetch(`${URL_BASE_REEMBOLSOS}/EliminarDocumento/${reembolsoDocumentoID}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });

  if (!res.ok) throw new Error(await res.text())

}

export const startRechazarReembolso = (reembolsoID, motivoRechazo) => async () => {
  const res = await fetch(`${URL_BASE_REEMBOLSOS}/RechazarReembolso`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify({ reembolsoID, motivoRechazo }),
  });
  if (!res.ok) throw new Error(await res.text());
};

export const startActualizarReembolso = (reembolsoID, monto, motivoReembolso, motivoAceptacion) => async () => {
  const res = await fetch(`${URL_BASE_REEMBOLSOS}/ActualizarReembolso`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify({ reembolsoID, monto, motivoReembolso, motivoAceptacion }),
  });
  if (!res.ok) throw new Error(await res.text());
};